import type { AttachmentItem } from '../../../../shared/components/generic-table/models/table-column.model';
import type { AttachmentType, CaseInvestigationIncidentRow } from '../models/case-investigation.models';

const MOCK_VIDEO_URL = '/videos/video-test.mp4';
const MOCK_THUMBNAIL_URL = '/thumbnail-template.png';

const builders: Record<AttachmentType, () => AttachmentItem[]> = {
  video: () => [
    {
      type: 'video',
      name: 'Surveillance Recording.mp4',
      url: MOCK_VIDEO_URL,
      videoUrl: MOCK_VIDEO_URL,
      thumbnailUrl: MOCK_THUMBNAIL_URL,
    },
  ],
  document: () => [{ type: 'document', name: 'Incident_Supporting_Report.pdf', url: '#' }],
  link: () => [
    { type: 'link', name: 'Policy Reference', url: 'https://example.com/policy/variance-guidelines' },
  ],
  multiple: () => [
    { type: 'document', name: "Feature Comparison: 'Ariel vs Nursery Dept 10 Oct 2025'", url: '#' },
    {
      type: 'video',
      name: 'Alibi Video.mp4',
      url: MOCK_VIDEO_URL,
      videoUrl: MOCK_VIDEO_URL,
      thumbnailUrl: MOCK_THUMBNAIL_URL,
    },
    { type: 'document', name: 'Assay Results.pdf', url: '#' },
    { type: 'document', name: 'LabResults-12/05/2025.pdf', url: '#' },
  ],
};

export function getAttachmentItems(row: CaseInvestigationIncidentRow): AttachmentItem[] {
  if (row.attachments != null && Array.isArray(row.attachments) && row.attachments.length > 0) {
    return row.attachments;
  }
  const kind = row.attachment;
  return kind ? (builders[kind]?.() ?? []) : [];
}

export const ATTACHMENT_KINDS: readonly AttachmentType[] = ['video', 'document', 'link', 'multiple'];
